module.exports = __webpack_public_path__ + "static/evolve-strong-fitness-logo-25e8950bd475a4053119db2cd9a390d2.png";